import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {
  IGlobalRatingPeriod,
  IProcessedPeriod,
  ISchoolYear,
} from '@core/interfaces/iratingperiod';
import { TranslocoService } from '@jsverse/transloco';
import { translateTermName } from '@core/services/helper.service';

@Component({
    selector: 'drdp-past-global-rating-periods',
    templateUrl: './past-global-rating-periods.component.html',
    styleUrls: ['./past-global-rating-periods.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PastGlobalRatingPeriodsComponent implements OnChanges {
  @Input() pastYears: ISchoolYear[] = [];
  @Input() pastPeriods: IGlobalRatingPeriod[] = [];
  processedPeriods: IProcessedPeriod[] = [];
  processedPerList: any = [];
  tableData?: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  formTableColumns = [
    { columnDef: 'schoolYear', header: '', type: 'text' },
    { columnDef: 'globalRatingPeriodName', header: '', type: 'text' },
    { columnDef: 'defaultStartDate', header: '', type: 'date', dateFormat: 'date' },
    { columnDef: 'defaultEndDate', header: '', type: 'date', dateFormat: 'date' },
    { columnDef: 'minStartDate', header: '', type: 'date', dateFormat: 'date' },
    { columnDef: 'maxEndDate', header: '', type: 'date', dateFormat: 'date' },
  ];

  constructor(private translocoService: TranslocoService) {}

  ngOnChanges(): void {
    if (this.pastYears.length > 0) {
      this.processRatingPeriodsData();
    }
  }

  processRatingPeriodsData(): void {
    let n = 0;
    for (let i in this.pastPeriods) {
      let per = this.pastPeriods[i];
      this.processedPeriods.push(<IProcessedPeriod>{
        sortOrder: this.getSortOrder(per),
        schoolYear: this.getSchoolYear(per),
        globalRatingPeriodName: translateTermName(
          per.globalRatingPeriodName.split(' ')[0],
          (key) => this.translocoService.translate(key)
        ),
        minStartDate: per.minStartDate,
        maxEndDate: per.maxEndDate,
        defaultStartDate: per.defaultStartDate,
        defaultEndDate: per.defaultEndDate,
      });
      n++;

      if (n == 4) {
        this.processedPeriods.sort((a, b) => a.sortOrder - b.sortOrder);
        this.processedPerList.push([...this.processedPeriods]);
        n = 0;
        this.processedPeriods.length = 0;
      }
    }
  }

  getTableDataSource(index: number): any {
    let source = new MatTableDataSource();
    source.data = this.processedPerList[index];
    return source;
  }
  getTableData(index: number): any {
    return this.processedPerList[index];
  }

  getSchoolYear(period: IGlobalRatingPeriod): string {
    let name = '';
    if (period.globalRatingPeriodName.split(' ')[0] == 'Fall') {
      const year = this.pastYears.filter((e) => e.id == period.schoolYearId);
      if (year.length > 0) {
        name = year[0].schoolYearName;
      }
    }
    return name;
  }

  getSortOrder(period: IGlobalRatingPeriod) {
    switch (period.globalRatingPeriodName.split(' ')[0]) {
      case 'Fall':
        return 1;
      case 'Winter':
        return 2;
      case 'Spring':
        return 3;
      default:
        return 4;
    }
  }
}
